import { render, staticRenderFns } from "./JMultiSelectTag.vue?vue&type=template&id=5463d78b&"
import script from "./JMultiSelectTag.vue?vue&type=script&lang=js&"
export * from "./JMultiSelectTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports